import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-deviation-type-menu',
  templateUrl: './deviation-type-menu.component.html',
  styleUrls: ['./deviation-type-menu.component.css']
})
export class DeviationTypeMenuComponent implements OnInit {
    deviationTypeKeyno;

    public deviationTypeNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'deviationtypelangs', gotoParms: () => this.menu!.deviationtype_keyno ?? '' }];

    public menu?: Menu;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.deviationTypeKeyno = this.stateService.getStateParams()['deviationtype_keyno'];
    }

    private async loadMenu() {
        if (!!this.deviationTypeKeyno) {
            this.menu = (await this.datatask.Post(1228, { deviationtype_keyno: this.deviationTypeKeyno }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1231, { deviationtype_keyno: this.menu.deviationtype_keyno }))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    deviationtype_keyno: string;
    deviationtype_name: string;
    deviationtype_status: string;
}
